module.exports = __webpack_public_path__ + "fonts/element-icons.732389de.ttf";